import { UIKitIcon } from '../icon';

export const profileIcon: UIKitIcon = {
  name: 'profile',
  // tslint:disable-next-line: max-line-length
  data: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="32.001" height="32.001" '
  + 'viewBox="0 0 32.001 32.001"><g><g transform="translate(-1695 167)"><circle cx="10" cy="10" r="10" transform="translate(1701 -161)" '
  + 'fill="none" stroke="inherit" stroke-miterlimit="10" stroke-width="1"/><path d="M54.445,100.111A3.5,3.5,0,0,0,51.867,99H42.978a3.5,3.5,'
  + '0,0,0-2.578,1.111" transform="translate(1663.578 -244)" fill="none" stroke="inherit" stroke-miterlimit="10" stroke-width="1"/>'
  + '<path d="M62,42c0,2.2-1.8,6-4,6s-4-3.8-4-6V40a4,4,0,1,1,8,0Z" transform="translate(1653 -195)" fill="none" stroke="inherit" '
  + 'stroke-miterlimit="10" stroke-width="1"/></g></g></svg>s',
};
